import {
    Can,
    FEATURE_FLAG_ACTIONS,
    FEATURE_FLAG_SUBJECTS,
} from '@/features/Casl';
import { Label } from 'flowbite-react';
import { Select, SelectRef } from '@/components/Select/Select';
import { useRef } from 'react';
import { OptimisationBase as OptimisationBaseType } from '@/optimizer';
import { InfoIcon, Typography } from '@analytical-alley/ui';

interface Props {
    optimizationBase: OptimisationBaseType;
    handleOptimizationBaseChange: (value: OptimisationBaseType) => void;
}

export const OptimisationBase = ({handleOptimizationBaseChange, optimizationBase}: Props) => {
    const selectRef = useRef<SelectRef>(null);

    return (
        <div className="flex flex-col gap-2">
            <Label
                onClick={() => {
                    selectRef?.current?.click?.();
                }}
                className="font-sans font-bold text-xs tracking-wider text-white/50 mb-1 flex gap-2"
                htmlFor="optimizationBase"
            >
                Optimization target{' '}
                <InfoIcon>
                    Select which KPI from the dashboard to use as your
                    optimization target.
                </InfoIcon>
            </Label>

            <Select
                id={'optimizationBase'}
                triggerRef={selectRef}
                className="w-full"
                selectedValue={optimizationBase}
                onSelectChange={handleOptimizationBaseChange}
                dismissOnClick
                label="Choose optimization base"
                compact
            >
                <Select.Option label={'Media Investment'} value={'budget'}>
                    <Typography variant="bodyM">Media Investment</Typography>
                    <Typography variant="bodyS" color="gray">
                        Total allocated media budget (without production cost)
                        that is invested in the following list of media channels
                    </Typography>
                </Select.Option>
                <Can
                    I={FEATURE_FLAG_ACTIONS.EDIT}
                    a={
                        FEATURE_FLAG_SUBJECTS.BUDGET_OPTIMIZATION_DASHBOARD_KPI_OPTIMISATION_MEDIA_KPI
                    }
                >
                    <Select.Option
                        label={'Media Contribution'}
                        value={'media_kpi'}
                    >
                        <Typography variant="bodyM">
                            Media Contribution
                        </Typography>
                        <Typography variant="bodyS" color="gray">
                            KPI generated directly by paid advertising
                            efforts
                        </Typography>
                    </Select.Option>
                </Can>
                <Can
                    I={FEATURE_FLAG_ACTIONS.EDIT}
                    a={
                        FEATURE_FLAG_SUBJECTS.BUDGET_OPTIMIZATION_DASHBOARD_KPI_OPTIMISATION_TOTAL_KPI
                    }
                >
                    <Select.Option
                        label={'Total Contribution'}
                        value={'total_kpi'}
                    >
                        <Typography variant="bodyM">
                            Total Contribution
                        </Typography>
                        <Typography variant="bodyS" color="gray">
                            Total KPI produced in a period
                        </Typography>
                    </Select.Option>
                </Can>
            </Select>
        </div>
    );
};
